import angular from 'angular';
import contactGroupsComponent from './contact-groups.component';
import contactGroupsBulkEditModal from './bulk-edit-modal';

export default angular
    .module('contactGroups', [
        contactGroupsBulkEditModal
    ])
    .component('contactGroups', contactGroupsComponent)
    .name; 